import * as React from 'react';
import {StatelessComponent} from 'react';
import {VideoSettingsLayout as Layout} from '../layout/layout';
import {VideoSettingsHeader as Header} from '../header/header';
import './styles.sass';

interface IVideoSettingsErrorScreenProps {
  message: string;
  onClose?: () => void;
}

export const VideoSettingsErrorScreen: StatelessComponent<IVideoSettingsErrorScreenProps> = ({
  message,
  onClose,
}: IVideoSettingsErrorScreenProps) => (
  <Layout>
    <Header onClose={onClose} />

    <div className={'video-settings-error-screen'}>
      {message}
    </div>
  </Layout>
);
